import axios, { CanceledError } from 'axios';
import { Dispatch, SetStateAction } from 'react';
import http from '../shared/HttpCommon';

const login = async (
  username: string,
  password: string,
  loading: Dispatch<SetStateAction<boolean>>,
  signal?: AbortSignal
) => {
  try {
    const params = new URLSearchParams();

    params.append('username', username);
    params.append('password', password);
    params.append('client_id', 'reputationplus-frontend');
    params.append('grant_type', 'password');

    loading(true);
    const { data } = await axios.post(
      process.env.REACT_APP_KC_BASE_URL + '/realms/reputationplus/protocol/openid-connect/token',
      params,
      {
        headers: {
          'Content-type': 'application/x-www-form-urlencoded',
        },
        signal,
      }
    );
    loading(false);
    return data;
  } catch (error) {
    if (error instanceof CanceledError) {
    } else {
      loading(false);
      console.error(error);
      return false;
    }
  }
};

const logout = async (access_token: string, refresh_token: string, signal?: AbortSignal) => {
  try {
    const params = new URLSearchParams();

    params.append('client_id', 'reputationplus-frontend');
    params.append('refresh_token', refresh_token);

    await axios.post(
      process.env.REACT_APP_KC_BASE_URL + '/realms/reputationplus/protocol/openid-connect/logout',
      params,
      {
        headers: {
          Authorization: 'Bearer ' + access_token,
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        signal,
      }
    );
  } catch (error) {
    if (error instanceof CanceledError) {
    } else {
      console.error(error);
    }
  }
};

const refreshToken = async (refresh_token: string, signal?: AbortSignal) => {
  try {
    const params = new URLSearchParams();

    params.append('grant_type', 'refresh_token');
    params.append('refresh_token', refresh_token);
    params.append('client_id', 'reputationplus-frontend');

    const { data } = await axios.post(
      process.env.REACT_APP_KC_BASE_URL + '/realms/reputationplus/protocol/openid-connect/token',
      params,
      {
        headers: {
          'Content-type': 'application/x-www-form-urlencoded',
        },
        signal,
      }
    );
    return data;
  } catch (error) {
    if (error instanceof CanceledError) {
    } else {
      console.error(error);
    }
  }
};

const loadUserProfile = async (access_token: string) => {
  try {
    const { data } = await axios.get(
      process.env.REACT_APP_KC_BASE_URL + '/realms/reputationplus/account',
      {
        headers: {
          Authorization: 'Bearer ' + access_token,
          'Content-Type': 'application/json',
        },
      }
    );
    return data;
  } catch (error) {
    console.log(error);
  }
};

const requestPasswordReset = async (
  email: string,
  lang: string | undefined,
  loading: Dispatch<SetStateAction<boolean>>
) => {
  try {
    loading(true);
    const response = await http.post('/auth/forgot-password', {
      email,
      lang,
    });
    return response.status === 202; // Accepted
  } catch (error) {
    console.error(error);
    return false;
  } finally {
    loading(false);
  }
};

const resetPassword = async (
  newPassword: string,
  confirmPassword: string,
  resetToken: string,
  loading: Dispatch<SetStateAction<boolean>>
) => {
  try {
    loading(true);
    const response = await http.post('/auth/reset-password', {
      newPassword,
      confirmPassword,
      resetToken,
    });
    return response.status === 200; // OK
  } catch (error) {
    console.error(error);
    return false;
  } finally {
    loading(false);
  }
};

const AuthService = {
  login,
  logout,
  refreshToken,
  loadUserProfile,
  requestPasswordReset,
  resetPassword,
};

export default AuthService;
